import React, { useRef, useEffect } from "react";

const useOutsideAlerter = (ref: React.MutableRefObject<null | HTMLDivElement>, setIsPopoverOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as HTMLElement)) {
        setIsPopoverOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setIsPopoverOpen]);
}

export const OutsideWrapper = (props: { children: React.ReactNode, setIsPopoverOpen: React.Dispatch<React.SetStateAction<boolean>>}) => {
  const {setIsPopoverOpen} = props;
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, setIsPopoverOpen);

  return (
    <div ref={wrapperRef}>{props.children}</div>
  );
}